/**
 * Created by dev on 11/02/14.
 */

$( document ).ready( function () {
    const grotecConfig = require( './../../config.js' ).default;

    $.ajaxSetup( {
        headers: {
            'X-CSRF-TOKEN': $( 'meta[name="csrf-token"]' ).attr( 'content' ),
            'Authorization': 'Bearer ' + grotecConfig.api.key
        },
        cache: true
    } );

    let mainNav = $( "#main-nav" );
    let cartInfo = $( ".cart-info" );

    $( "#subLoader" ).first().addClass( 'active' );

    $( window ).bind( "scroll", function () {
        closeCart();
        $( ".tip" ).tooltip( 'hide' );
    } ).trigger( 'scroll' );

    $( "body" ).on( 'hidden.bs.modal', '.modal', function () {
        $( this ).removeData( 'bs.modal' );
    } ).on( 'click', '#town-letter', function ( e ) {
        e.preventDefault();
        let target = $( "#town-list" );

        let letter = {
            'letter': $( this ).data( 'letter' )
        };


        $.post( {
            url: '/location/townList',
            data: letter,
            beforeSend: function () {
                target.fadeOut();
            },
            success: function ( data ) {
                target.html( data );
                target.fadeIn();
            },
            error: function ( jqXHR, textStatus ) {
                target.fadeIn();
            }
        } );
    } ).on( 'click', '.popup', function ( e ) {
        e.preventDefault();

        let self = $( this );
        let width = 575;
        let height = 400;
        let left = ( $( window ).width() - width ) / 2;
        let top = ( $( window ).height() - height ) / 2;
        let url = self.attr( 'href' );
        let title = self.attr( 'id' );
        let opts = 'status=1' +
            ',width=' + width +
            ',height=' + height +
            ',top=' + top +
            ',left=' + left +
            'menubar=no,' +
            'toolbar=no,' +
            'resizable=no,' +
            'scrollbars=no';

        window.open( url, title, opts );
    } ).on( "mouseenter", ".project-well", function () {
        let _well = $( this );

        _well.css( 'background-color', '#ffffff' );
        _well.children( '.fa-leaf' ).css( 'color', '#3f99e0' );
        _well.children( '.projects-read-more' ).css( 'color', '#3f99e0' );
    } ).on( "mouseleave", ".project-well", function () {
        let _well = $( this );
        _well.css( 'background-color', '#f5f5f5' );
        _well.children( '.fa-leaf' ).css( 'color', '#333333' );
        _well.children( '.projects-read-more' ).css( 'color', '#333333' );
    } ).on( 'click', '.tip', function ( e ) {
        e.preventDefault();
    } ).on( 'submit', '#searchForm', function ( e ) {
        e.preventDefault();
    } ).on( 'click', '.preorder-btn', function ( e ) {
        let myModal = $( ".preorder-modal" );
        let myFrm = $( ".preorder-form" );

        $.ajax( {
            url: 'cart/preorder',
            type: 'POST',
            data: myFrm.serialize(),
            dataType: 'html',
            success: function ( data ) {
                myModal.find( '.modal-body' ).html( data );
                setTimeout( function () {
                    myModal.modal( 'hide' );
                }, 1000 );
            }
        } );


    } ).on( "click", ".remove-item", function ( e ) {
        let item = $( this );
        let itemId = item.data( 'itemid' );
        let event = e;
        event.preventDefault();

        $.ajax( {
            url: '/api/v2/sales/' + Laravel.cartId + '/items/' + itemId,
            type: 'DELETE',
            dataType: 'json',
            success: function () {
                loadSmallCart( event )
            }
        } );
    } ).on( "click", ".cart-close", function ( e ) {
        closeCart( e );
    } );

    let address = window.location.href;

    /*if (address.indexOf('shop') === -1) {

        $('.search-fixed-top').pageSearch(
            {
                url: '/search/products/display',
                target: '.searchResults'
            }
        );
    }*/


    if ( typeof $.fn.bootstrapValidator !== 'undefined' ) {

        let contactForm = $( "#contactFrm" );

        if ( typeof contactForm !== 'undefined' ) {
            contactForm.bootstrapValidator( {
                excluded: [ ':disabled', ':hidden', ':not(:visible)' ],
                feedbackIcons: {
                    valid: 'glyphicon glyphicon-ok',
                    invalid: 'glyphicon glyphicon-remove',
                    validating: 'glyphicon glyphicon-refresh'
                },
                live: 'enabled',
                submitButtons: 'button[type="submit"]',
                fields: {
                    contactName: {
                        validators: {
                            notEmpty: {
                                message: 'We will need a contact name'
                            }
                        }
                    },
                    contactEmail: {
                        validators: {
                            notEmpty: {
                                message: 'We will need your email address'
                            },
                            emailAddress: {
                                message: 'The value is not a valid email address'
                            }
                        }
                    },
                    contactMessage: {
                        validators: {
                            notEmpty: {
                                message: 'Send us a message'
                            }
                        }
                    }
                }
            } ).on( 'submit', function ( e ) {
                let frm = $( this );
                e.preventDefault();

                $.ajax( {
                    url: frm.attr( 'action' ),
                    type: 'POST',
                    data: frm.serialize(),
                    dataType: 'html',
                    success: function ( data ) {
                        frm.parent().html( data );
                    }
                } )
            } );
        }
    }

    mainNav.on( "click", ".cart-dropdown", function ( e ) {
        loadSmallCart( e );
    } );

    let cache = {}, lastXhr;


    $( '.askModal' )
        .on( 'submit', '.askForm', function ( e ) {
            e.preventDefault();

            setTimeout( function () {
                $( '.askModal' ).modal( 'toggle' );
            }, 3000 );
        } )
        .on( 'click', '.submitAsk', function () {
            $( '.askForm' ).submit();
        } );


    function closeCart( e ) {
        if ( typeof ( e ) != "undefined" ) {
            e.preventDefault();
        }

        $( ".cart-info" ).fadeOut( 'slow' ).empty();
        let myModal = $( ".cart-modal" );
        myModal.modal( 'hide' );
    }


    function loadSmallCart( e ) {
        e.preventDefault();

        $.ajax( {
            url: '/shop/small-cart',
            type: 'GET',
            dataType: 'html',
            xhrFields: {
                withCredentials: true
            },
            success: function ( data ) {
                if ( isMobile.any() ) {
                    let myModal = $( ".cart-modal" );
                    myModal.find( '.modal-body' ).html( data );
                    myModal.find( '.cart-close' ).remove();
                    myModal.modal( 'show' );
                } else {
                    cartInfo.html( data ).fadeIn( {
                        duration: 300,
                        easing: 'linear'
                    } );
                }
            }
        } );
    }

    let isMobile = {
        Android: function () {
            return navigator.userAgent.match( /Android/i );
        },
        BlackBerry: function () {
            return navigator.userAgent.match( /BlackBerry/i );
        },
        iOS: function () {
            return navigator.userAgent.match( /iPhone|iPad|iPod/i );
        },
        Opera: function () {
            return navigator.userAgent.match( /Opera Mini/i );
        },
        Windows: function () {
            return navigator.userAgent.match( /IEMobile/i );
        },
        any: function () {
            return ( isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows() );
        }
    };
} );